'use client';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'next/navigation';

import Markdown from '@components/utils/Markdown';
import Breadcrumb from '@components/Breadcrumb/Breadcrumb';
import HeroCampaignBanner from '@components/ui/banners/hero-campaign-banner/HeroCampaignBanner';
import { FlexibleDiv } from '@components/formStyles';
import { callService } from '@api/remote-call';
import { useDevice } from '@contexts/device';

import {
  Layout,
  ContainerItem,
  CampaignPromotionsWrapper,
  SearchContainer,
  ContentContainer,
} from './styled';
import { CampaignPromotions } from '../../landing/components/campaign/CampaignPromotions/CampaignPromotions';
import PopularCitiesContainer from './PopularCitiesContainer';
import { formatToCampaignsBannerData } from '../../homepage/formats';
import { LandingBannerContainer } from '../../homepage/HomeStyle';
import SearchBar from './SearchBar';
import ItemInfo from './ItemInfo';

const breadCrumbItems = [
  { title: 'Ana Sayfa', url: '/' },
  { title: 'Uçak', url: '' },
];

const FlightTicket = () => {
  const { isDesktop } = useDevice();

  const params = useParams();

  const { data } = useQuery(
    ['flight-city-landing', params],
    async () => {
      return callService(
        {
          service: 'ContentsService',
          method: 'getFlightCityLanding',
          version: 'v3',
        },
        {
          slug: params?.slug as string,
        }
      );
    },
    { enabled: !!params?.slug }
  );

  return (
    <>
      <Layout>
        {data ? (
          <>
            <SearchContainer>
              {data.searchBar ? (
                <ContainerItem marginTop={isDesktop ? 40 : 20}>
                  <SearchBar
                    data={data?.searchBar?.[0]}
                    showIsCheckbox={true}
                  />
                </ContainerItem>
              ) : null}
              <ContainerItem marginTop={20}>
                <ContentContainer>
                  <Breadcrumb items={breadCrumbItems} />
                </ContentContainer>
              </ContainerItem>
            </SearchContainer>
            <ContentContainer>
              <ContainerItem marginTop={20}>
                <ItemInfo
                  title={data.description1?.[0]?.title ?? ''}
                  description=''
                  hasTopMargin={false}
                />
                <Markdown text={data.description1[0]?.text ?? ''} />
                <FlexibleDiv top={60} bottom={40}>
                  <PopularCitiesContainer data={data.listings} />
                </FlexibleDiv>
              </ContainerItem>

              {data.description2 ? (
                <ContainerItem marginTop={40}>
                  <ItemInfo
                    title={data?.description2?.[0]?.title ?? ''}
                    description=''
                    hasTopMargin={false}
                  />
                  <Markdown text={data?.description2?.[0]?.text ?? ''} />

                  {isDesktop ? <FlexibleDiv bottom={20} /> : null}
                </ContainerItem>
              ) : null}

              <ContainerItem>
                <ItemInfo
                  title={data?.description3?.[0]?.title ?? ''}
                  description=''
                />
                <Markdown text={data?.description3?.[0]?.text ?? ''} />
              </ContainerItem>
              <ContainerItem>
                <ItemInfo
                  title={data?.description4?.[0]?.title ?? ''}
                  description=''
                />
                <Markdown text={data?.description4?.[0]?.text ?? ''} />
              </ContainerItem>
              <ContainerItem>
                <CampaignPromotionsWrapper>
                  <ItemInfo
                    title={data.campaignPromotion?.[0]?.title ?? ''}
                    description={data.campaignPromotion?.[0]?.text ?? ''}
                  />
                  {data.campaignPromotion ? (
                    <CampaignPromotions
                      data={data.campaignPromotion?.[0]?.items}
                      link={data.campaignPromotion?.[0]?.link?.[0]}
                      showHeader={false}
                      linkPosition='flex-start'
                      imagesKey='homePageImages'
                    />
                  ) : null}
                </CampaignPromotionsWrapper>
              </ContainerItem>
              <ContainerItem>
                <ItemInfo
                  title={data.description5?.[0]?.title ?? ''}
                  description=''
                />
                <Markdown text={data?.description5?.[0]?.text ?? ''} />
              </ContainerItem>
              {data.campaignBanner ? (
                <ContainerItem>
                  <LandingBannerContainer>
                    <HeroCampaignBanner
                      data={formatToCampaignsBannerData(
                        data.campaignBanner[0],
                        Boolean(isDesktop)
                      )}
                    />
                  </LandingBannerContainer>
                </ContainerItem>
              ) : null}
            </ContentContainer>
          </>
        ) : null}
      </Layout>
      <FlexibleDiv bottom={20} />
    </>
  );
};

export default FlightTicket;
